import React from 'react';

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
  }

  render() {
  const date = new Date();
  const year = date.getFullYear();
    return (
      <React.Fragment>
        <footer className="footer-section">
          <div
            className="footer-top background-img-2 py-5"
            style={{
              backgroundImage: "url('/img/footer-bg.png')",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center top',
              backgroundSize: 'cover',
            }}
          >
            <div className="container">
              <div className="row justify-content-between">
                <div className="col-lg-3 mb-3 mb-lg-0">
                  <div className="footer-nav-wrap text-white">
                    <img
                      src="/img/logo-white-1x.svg"
                      alt="footer logo"
                      width="120"
                      className="img-fluid mb-3"
                      loading="lazy"
                    />
                    <p className="text-white">
                      We are exploring on our time off! Follow us on social for outdoor adventure inspo!
                    </p>

                    <div className="social-list-wrap">
                      <ul className="social-list list-inline list-unstyled">
                        <li className="list-inline-item">
                          <a
                            href="https://www.facebook.com/exploroff"
                            target="_blank"
                            title="Facebook"
                          >
                            <span className="ti-facebook"></span>
                          </a>
                        </li>
                        <li className="list-inline-item">
                          <a
                            href="https://www.linkedin.com/company/exploroff"
                            target="_blank"
                            title="Linkedin"
                          >
                            <span className="ti-linkedin"></span>
                          </a>
                        </li>
                        <li className="list-inline-item">
                          <a
                            href="https://www.tiktok.com/@exploroff"
                            target="_blank"
                            title="TikTok"
                          >
                            <span className="ti-music"></span>
                          </a>
                        </li>
                        <li className="list-inline-item">
                          <a
                            href="https://www.instagram.com/exploroff"
                            target="_blank"
                            title="Instagram"
                          >
                            <span className="ti-instagram"></span>
                          </a>
                        </li>
                        <li className="list-inline-item">
                          <a
                            href="https://www.youtube.com/@exploroff"
                            target="_blank"
                            title="YouTube"
                          >
                            <span className="ti-youtube"></span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 ml-auto mb-4 mb-lg-0">
                  <div className="footer-nav-wrap text-white">
                    <h5 className="mb-3 text-white">Road Trips</h5>
                    <ul className="list-unstyled">
                      <li className="mb-2"><a href="/itineraries/yellowstone-grand-teton">Yellowstone &amp; Grand Teton</a></li>
                      <li className="mb-2"><a href="/itineraries/utah-national-parks-road-trip">Utah National Parks Loop</a></li>
                      <li className="mb-2"><a href="/itineraries/olympic-peninsula-loop">Olympic Peninsula Loop</a></li>
                      <li className="mb-2"><a href="/itineraries/blue-ridge-parkway">Blue Ridge Parkway</a></li>
                      <li className="mb-2"><a href="/itineraries/glacier-national-park-memorial-day">Glacier National Park</a></li>
                      <li className="mb-2"><a href="/itineraries/banff-national-park">Banff National Park</a></li>
                      <li className="mb-2"><a href="/itineraries/kayak-colorado-river">Colorado River Kayaking</a></li>
                      <li className="mb-2"><a href="/itineraries">All Itineraries →</a></li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 ml-auto mb-4 mb-lg-0">
                  <div className="footer-nav-wrap text-white">
                    <h5 className="mb-3 text-white">National Parks</h5>
                    <ul className="list-unstyled">
                      <li className="mb-2"><a href="/itineraries/acadia-national-park">Acadia NP · Maine</a></li>
                      <li className="mb-2"><a href="/itineraries/great-smoky-mountains-national-park">Great Smoky Mountains</a></li>
                      <li className="mb-2"><a href="/itineraries/rocky-mountain-national-park">Rocky Mountain NP</a></li>
                      <li className="mb-2"><a href="/itineraries/grand-canyon-south-rim">Grand Canyon South Rim</a></li>
                      <li className="mb-2"><a href="/itineraries/zion-national-park">Zion National Park</a></li>
                      <li className="mb-2"><a href="/itineraries/shenandoah-national-park">Shenandoah NP</a></li>
                      <li className="mb-2"><a href="/itineraries/boundary-waters-canoe-area">Boundary Waters</a></li>
                      <li className="mb-2"><a href="/find-my-trip">Find My Trip →</a></li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="footer-nav-wrap text-white">
                    <h5 className="mb-3 text-white">Backpacking &amp; Trails</h5>
                    <ul className="list-unstyled">
                      <li className="mb-2"><a href="/itineraries/north-cascades-backpacking">North Cascades</a></li>
                      <li className="mb-2"><a href="/itineraries/john-muir-trail-section">John Muir Trail</a></li>
                      <li className="mb-2"><a href="/itineraries/kings-canyon-backpacking">Kings Canyon</a></li>
                      <li className="mb-2"><a href="/itineraries/isle-royale-backpacking">Isle Royale</a></li>
                      <li className="mb-2"><a href="/itineraries/pictured-rocks-backpacking">Pictured Rocks</a></li>
                      <li className="mb-2"><a href="/itineraries/appalachian-trail-shenandoah">Appalachian Trail</a></li>
                      <li className="mb-2"><a href="/itineraries/haleakala-sunrise-hike">Haleakalā · Maui</a></li>
                      <li className="mb-2"><a href="/submit-itinerary">Submit Your Itinerary →</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom gray-light-bg pt-4 pb-4">
            <div className="container">
              <div className="row text-center justify-content-center">
                <div className="col-md-6 col-lg-5">
                  <p className="copyright-text pb-0 mb-0">
                    Copyrights © {year}. All rights reserved by
                    <a href="https://exploroff.com/"> ExplorOFF</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </React.Fragment>
    );
  }
}

export default Footer;
